import React from 'react';
import { ListItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import DataCard from './dataCard';
import { createTheme } from '@mui/material/styles';
const theme = createTheme();

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
        width:'100%'
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        // boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.4)',
        // boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)', // made the changes for consistent styling
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',
        borderRadius: theme.spacing(0.5),
        padding: theme.spacing(1),
        // background: 'linear-gradient(to bottom, #e4e4e4, #ffffff)',
        width:'100%',
        // border:'solid 1px #638CDB',
    },
}));

const DataListRow = (props) =>
{
    const classes = useStyles();
    const { item, index } = props;

    return (
        <ListItem className={classes.listItemContent}>
            <DataCard
                classes={classes}
                item={item}
                index={index}
                {...props}
            />
        </ListItem>
    );
};

export default DataListRow;
